import { OneSecondInMillis } from '@racemap/utilities/consts/time';

export const DEFAULT_RELOAD_INTERVAL_PLAYER = OneSecondInMillis * 30;
export const MAX_STARTERS_FOR_AUTO_RELOAD_PLAYER = 750;
